import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noPlans: {
		id: 'navigation-apps-sidebar-nav4-plans.plans.common.empty-content.no-plans',
		defaultMessage: "Once you open or create plans, they'll show up here.",
		description: 'Message for no plans in the plans menu items',
	},
});
